// src/area/ConfigEventArea.jsx
import React from "react";
import CardConfigEvent from "../../components/Cards/CardConfiguration/CardConfigEvent/CardConfigEvent";

// FTR-0066: `onEventSaved` llega de ListCategoriasSection (pestaña Cómputo sin recargar la página).
const ConfigEventArea = ({ onEventSaved } = {}) => {
  return (
    <>
      <div>
        <CardConfigEvent onSaved={onEventSaved} />
      </div>
    </>
  );
};

export default ConfigEventArea;
